/**
 * Strings to match a client-side search query against for a date that comes from the backend
 * as `yyyy-MM-dd` (e.g. `2026-07-16`): the raw value, the same date with dots (`2026.07.16`)
 * and the format the UI shows it in (`dd.MM.yyyy` → `16.07.2026`).
 */
export function getDateSearchVariants(date: string | Date): string[] {
  if (!date) { return []; }
  const raw = String(date);
  const [year, month, day] = raw.slice(0, 10).split('-');
  if (!year || !month || !day) { return [raw]; }
  return [raw, `${year}.${month}.${day}`, `${day}.${month}.${year}`];
}
